module.exports = __webpack_public_path__ + "img/analytics-bg-3.8cb42cc1.png";